<proffeo-task-view-settings
  (groupToggled)="toggleGroup($event)"
  (settingChanged)="updateSetting($event)"
  [bulkToggle]="true"
  [groupEnabled]="groupEnabled()"
  [labelKey]="'task-details-view-settings.title'"
  [sections]="sections"
  [values]="values()"
/>
